import { inject } from '@angular/core';
import { PendoAnalyticsService } from 'src/app/services/pendo/pendo-analytics.service';

/** Constructs {@link PendoAnalyticsService} at bootstrap so auth/route listeners are active. */
export function pendoAnalyticsInitializer(): void {
  inject(PendoAnalyticsService);
}
